import { useState } from 'react';
import PropTypes from "prop-types";
import './Template.scss';
import { useNavigate } from "react-router-dom";
import { showConfirmationToast } from "../../../common/toasts/utils";
import { deleteTemplate } from "../../../../utils/api/templates";

const Template = ({template}) => {
    const navigate = useNavigate();
    const [isDeleting, setIsDeleting] = useState(false);
    const {company, title} = template;

    const handleTemplateApply = () => {
        template.endDate = undefined;
        navigate('/create-lunch', {state: template});
    };

    const handleTemplateEdit = () => {
        navigate('/template', {state: {template, id: template.id}});
    };
    const handleTemplateDeleteConfirmed = () => {
        const handleTemplateDeleteSuccess = () => {
            navigate(0);
        };
        const handleTemplateDeleteError = () => {
            setIsDeleting(false);
        };
        setIsDeleting(true);
        deleteTemplate(template.id, handleTemplateDeleteSuccess, handleTemplateDeleteError);
    };
    const handleTemplateDelete = () => {
        showConfirmationToast(
            <div>Do you want to remove <b>{title}</b> template?</div>,
            handleTemplateDeleteConfirmed
        );
    };
    return (
        <div className="template">
            <div>
                <div className="template__header">{company}</div>
                <div className="template__description">{title}</div>
            </div>
            {isDeleting && <div className="loader" id="loader-1"/>}
            {!isDeleting && (
                <div className="template__buttons">
                    <div className="template__icon template__icon--edit" onClick={handleTemplateEdit}/>
                    <div className="template__icon template__icon--delete" onClick={handleTemplateDelete}/>
                    <button className="template__button" onClick={handleTemplateApply}>Apply</button>
                </div>
            )}
        </div>
    );
};

Template.propTypes = {
    template: PropTypes.object.isRequired
}

export default Template;
